import { IFilterDto, IPagination, TFieldDefinition } from "../../common/model/Core.model"

export interface IContactDto {
  createdAt: string
  updatedAt: string
  organizationId: string
  userId: string
  primary: boolean
  id: string
  sequence: string
  type: ContactType
  displayName: string
  email: string
  telephone: string
  countryCode: string
  country: string
  address: string
  details: IContactDetailDto[]
  photoUrl: string
}

export interface IContactNestedDto {
  createdAt: string;
  updatedAt: string;
  userId?: string;
  primary: boolean;
  id: string;
  sequence: string;
  displayName: string;
  email: string;
  telephone?: string;
  countryCode?: string;
  country?: string;
  address?: string;
  details?: IContactDetailDto[];
  photoUrl?: string;
}

export interface IContactCreateRequestDto {
  displayName: string
  email: string
  telephone: string
  countryCode: string
  country: string
  address: string
  details: IContactDetailDto[]
  photoUrl: string
}

export interface IContactUpdateRequestDto {
  id: string
  displayName?: string
  email?: string
  telephone?: string
  countryCode?: string
  country?: string
  address?: string
  details: IContactDetailDto[]
  photoUrl: string
}

export interface IContactSearchRequestDto {
  organizationId?: string
  pagination?: IPagination
  fields?: TFieldDefinition
  filters?: IFilterDto[]
}

export interface IContactCheckRequestDto {
  email: string
}

export interface IContactDetailDto {
  type?: ContactDetailsType
  value?: string
}

export enum ContactDetailsType {
  EMAIL = 'EMAIL',
  FAX = 'FAX',
  MOBILE = 'MOBILE',
  OTHER = 'OTHER',
  TELEPHONE = 'TELEPHONE',
  SOCIAL = 'SOCIAL',
  WEBSITE = 'WEBSITE',
}

export enum ContactType {
  CONTACT = 'CONTACT',
  TEAM = 'TEAM',
  USER = 'USER',
}

export enum IContactFilter {
  HASH = 'HASH',
  ID = 'ID',
  NAME = 'NAME',
  COUNTRY = 'COUNTRY',
  ADDRESS = 'ADDRESS',
  EMAIL = 'EMAIL',
  TELEPHONE = 'TELEPHONE',
  DETAIL = 'DETAIL',
  TYPE = 'TYPE'
}

export const mapClientNestedEntity = (entity: IContactDto): IContactNestedDto => ({
  createdAt: entity.createdAt ?? '',
  updatedAt: entity.updatedAt ?? '',
  userId: entity.userId ?? '',
  primary: false,
  id: entity.id ?? '',
  sequence: entity.sequence ?? '',
  displayName: entity.displayName ?? '',
  email: entity.email ?? '',
  telephone: entity.telephone ?? '',
  countryCode: entity.countryCode ?? '',
  country: entity.country ?? '',
  address: entity.address ?? '',
  details: entity.details || [],
  photoUrl: entity.photoUrl ?? '',
})

// export const sanitizeContactInfo = (contacts: IContactDto[]): IContactNestedDto[] => {
//   return contacts.map((contact) => mapClientNestedEntity(contact))
// }